import { EKwikUITextareaSize } from "./textarea.definitions";

export const DEFAULT_VALUES = {
  label: "Input",
  id: "textarea",
  formControlName: "form_control_textarea",
  placeholder: "Please enter textarea",
  focus: false,
  invalid: false,
  disabled: false,
  size: EKwikUITextareaSize.L
};

export const VALIDATE_KEY_VALUES = {
  label: true,
  id: true,
  formControlName: true,
  focus: true,
  invalid: true,
  disabled: true,
  size: true,
  placeholder: true
};
